import React from 'react';
import PropTypes from 'prop-types';
import { CardContent, Rating, Link, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { MediaCard } from '../../../../../components';
import { formatDate } from '../../../../../utils';
import { APP_ROUTES } from '../../../../../constants/app-routes';
import { useStorageImage } from '../../../../../hooks';
import venuePlaceholder from '../../../../../assets/img/venue-placeholder.jpg';

function UserCard({ user }) {
  const userImage = useStorageImage(user.venue?.banner);

  const image = userImage ?? venuePlaceholder;

  const navigateToDetails = (venueId = null) => {
    if (venueId === undefined) return '';
    return APP_ROUTES?.VENUE_PUBLIC_PROFILE.replace(':venueId', venueId);
  };
  return (
    <MediaCard image={image}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" component="div">
          <Link href={navigateToDetails(user.venue.id)}> {`${user.name} ${user.last_name}`}</Link>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Est. {formatDate(user.created_at)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Location: {user.venue.business_address}
        </Typography>
        <Rating disabled value={user.averageScore} />
      </CardContent>
    </MediaCard>
  );
}

UserCard.propTypes = {
  user: PropTypes.instanceOf(Object).isRequired,
};

export default UserCard;
